<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 480 480" style="enable-background:new 0 0 480 480;" xml:space="preserve">
<g>
	<g>
		<path d="M125.112,383.126c-5.46-3.631-11.692-5.937-18.2-6.736c12.484-9.827,20.161-24.531,21.088-40.392
			c0-52.896-30.456-64-56-64s-56,11.104-56,64c0.929,15.862,8.609,30.566,21.096,40.392C15.89,379.003-0.031,397.031,0,418.398v53.6
			c0,4.418,3.582,8,8,8h128c4.418,0,8-3.582,8-8v-53.6C144.009,404.219,136.918,390.978,125.112,383.126z M32.416,327.534
			C34.584,300.718,47.2,287.998,72,287.998c22.704,0,35.2,10.736,38.776,33.136l-26.656-16c-3.789-2.273-8.703-1.044-10.976,2.745
			c-0.3,0.5-0.544,1.03-0.728,1.583C68.368,321.606,46.512,326.198,32.416,327.534z M33.112,343.582
			c13.696-1.128,38.4-5.272,49.92-20.44l28.592,17.16C108.416,359.894,84.28,375.998,72,375.998
			C54.157,372.959,39.314,360.586,33.112,343.582z M78.608,422.062L72,428.686l-6.608-6.616L72,405.534L78.608,422.062z
			 M128,463.998H16v-45.6c0-14.58,11.82-26.4,26.4-26.4h17.76L48.568,421.03c-1.185,2.971-0.487,6.363,1.776,8.624l16,16
			c3.124,3.123,8.188,3.123,11.312,0l16-16c2.263-2.261,2.961-5.653,1.776-8.624l-11.616-29.032H101.6c14.58,0,26.4,11.82,26.4,26.4
			V463.998z"/>
	</g>
</g>
<g>
	<g>
		<path d="M293.112,383.126c-5.46-3.631-11.692-5.937-18.2-6.736c12.484-9.827,20.161-24.531,21.088-40.392
			c0-52.896-30.456-64-56-64s-56,11.104-56,64c0.929,15.862,8.609,30.566,21.096,40.392c-21.206,2.613-37.127,20.641-37.096,42.008
			v53.6c0,4.418,3.582,8,8,8h128c4.418,0,8-3.582,8-8v-53.6C312.009,404.219,304.918,390.978,293.112,383.126z M200.416,327.534
			c2.168-26.816,14.784-39.536,39.584-39.536c22.704,0,35.2,10.736,38.776,33.136l-26.656-16c-3.789-2.273-8.703-1.044-10.976,2.745
			c-0.3,0.5-0.544,1.03-0.728,1.583C236.368,321.606,214.512,326.198,200.416,327.534z M201.112,343.582
			c13.696-1.128,38.4-5.272,49.92-20.44l28.592,17.16c-3.208,19.592-27.344,35.696-39.624,35.696
			C222.157,372.959,207.314,360.586,201.112,343.582z M246.608,422.062L240,428.686l-6.608-6.616L240,405.534L246.608,422.062z
			 M296,463.998H184v-45.6c0-14.58,11.82-26.4,26.4-26.4h17.76l-11.616,29.032c-1.185,2.971-0.487,6.363,1.776,8.624l16,16
			c3.124,3.123,8.188,3.123,11.312,0l16-16c2.263-2.261,2.961-5.653,1.776-8.624l-11.592-29.032H269.6c14.58,0,26.4,11.82,26.4,26.4
			V463.998z"/>
	</g>
</g>
<g>
	<g>
		<path d="M461.112,383.126c-5.46-3.631-11.692-5.937-18.2-6.736c12.484-9.827,20.161-24.531,21.088-40.392
			c0-52.896-30.456-64-56-64s-56,11.104-56,64c0.929,15.862,8.609,30.566,21.096,40.392c-21.206,2.613-37.127,20.641-37.096,42.008
			v53.6c0,4.418,3.582,8,8,8h128c4.418,0,8-3.582,8-8v-53.6C480.009,404.219,472.918,390.978,461.112,383.126z M368.416,327.534
			c2.168-26.816,14.784-39.536,39.584-39.536c22.704,0,35.2,10.736,38.776,33.136l-26.656-16c-3.789-2.273-8.703-1.044-10.976,2.745
			c-0.3,0.5-0.544,1.03-0.728,1.583C404.368,321.606,382.512,326.198,368.416,327.534z M369.112,343.582
			c13.696-1.128,38.4-5.272,49.92-20.44l28.592,17.16c-3.208,19.592-27.344,35.696-39.624,35.696
			C390.157,372.959,375.314,360.586,369.112,343.582z M414.608,422.062L408,428.686l-6.608-6.616L408,405.534L414.608,422.062z
			 M464,463.998H352v-45.6c0-14.58,11.82-26.4,26.4-26.4h17.76l-11.616,29.032c-1.185,2.971-0.487,6.363,1.776,8.624l16,16
			c3.124,3.123,8.188,3.123,11.312,0l16-16c2.263-2.261,2.961-5.653,1.776-8.624l-11.592-29.032H437.6c14.58,0,26.4,11.82,26.4,26.4
			V463.998z"/>
	</g>
</g>
<g>
	<g>
		<path d="M368,239.998v-104c0-4.418-3.582-8-8-8h-72v-24c0-4.418-3.582-8-8-8h-48.6c-11.748-20.436-33.799-32.738-57.36-32
			C138.943,65.964,111.607,95.2,112,130.35c-0.013,20.888,5.944,41.344,17.168,58.96l32.256,50.688H152v16h224v-16H368z
			 M200,239.998h-9.424L200,225.19V239.998z M176,233.102l-33.328-52.384c-9.592-15.047-14.683-32.523-14.672-50.368
			c-0.453-26.524,20.044-48.709,46.52-50.352H176c26.51,0,48,21.49,48,48v2.352c0.017,17.856-5.074,35.343-14.672,50.4L176,233.102z
			 M272,239.998h-56v-39.96l6.832-10.728c11.224-17.616,17.181-38.072,17.168-58.96v-2.352c-0.019-5.399-0.718-10.775-2.08-16H272
			V239.998z M328,239.998h-16v-24h16V239.998z M352,151.998h-16v16h16v8h-16v16h16v48h-8v-32c0-4.418-3.582-8-8-8h-32
			c-4.418,0-8,3.582-8,8v32h-8v-48h16v-16h-16v-8h16v-16h-16v-8h64V151.998z"/>
	</g>
</g>
<g>
	<g>
		<rect x="248" y="119.998" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="312" y="151.998" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="312" y="175.998" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="248" y="143.998" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="248" y="167.998" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="224" y="191.998" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="248" y="191.998" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="224" y="215.998" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="248" y="215.998" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<path d="M443.944,166.918l-15.688,3.16c0.984,4.888,1.784,9.888,2.4,14.856l15.864-1.888
			C445.872,177.654,445.008,172.23,443.944,166.918z"/>
	</g>
</g>
<g>
	<g>
		<path d="M36,167.302c-1.08,5.344-1.928,10.76-2.56,16.104l15.888,1.872c0.576-4.928,1.376-9.936,2.352-14.88L36,167.302z"/>
	</g>
</g>
<g>
	<g>
		<path d="M421.312,105.99l-13.936,7.856c2.456,4.344,4.8,8.848,6.88,13.4l14.504-6.752
			C426.472,115.574,423.96,110.694,421.312,105.99z"/>
	</g>
</g>
<g>
	<g>
		<path d="M403.136,78.934l-12.56,9.936c3.096,3.896,6.088,8,8.896,12.168l13.264-8.936
			C409.696,87.59,406.464,83.158,403.136,78.934z"/>
	</g>
</g>
<g>
	<g>
		<path d="M76.696,79.198c-3.368,4.24-6.6,8.68-9.616,13.176l13.296,8.904c2.776-4.152,5.76-8.248,8.864-12.176L76.696,79.198z"/>
	</g>
</g>
<g>
	<g>
		<path d="M380.96,55.046l-10.848,11.76c3.704,3.424,7.296,7,10.664,10.632l11.736-10.872
			C388.864,62.63,384.976,58.75,380.96,55.046z"/>
	</g>
</g>
<g>
	<g>
		<path d="M58.536,106.254c-2.64,4.696-5.144,9.592-7.432,14.544l14.512,6.72c2.12-4.576,4.432-9.096,6.856-13.408L58.536,106.254z"
			/>
	</g>
</g>
<g>
	<g>
		<path d="M44.848,135.894c-1.896,5.12-3.592,10.344-5.048,15.528l15.392,4.344c1.352-4.8,2.92-9.6,4.672-14.336L44.848,135.894z"/>
	</g>
</g>
<g>
	<g>
		<path d="M98.824,55.238c-4,3.672-7.856,7.552-11.536,11.536L99.04,77.63c3.36-3.664,6.976-7.232,10.64-10.64L98.824,55.238z"/>
	</g>
</g>
<g>
	<g>
		<path d="M435.048,135.566l-15,5.56c1.752,4.712,3.328,9.528,4.688,14.32l15.392-4.376
			C438.648,145.878,436.928,140.67,435.048,135.566z"/>
	</g>
</g>
<g>
	<g>
		<path d="M183.416,7.798c-5.248,1.488-10.472,3.2-15.504,5.048l5.544,15c4.648-1.712,9.472-3.28,14.32-4.656L183.416,7.798z"/>
	</g>
</g>
<g>
	<g>
		<path d="M215.416,1.446c-5.344,0.632-10.768,1.488-16.112,2.536l3.096,15.704c4.944-0.976,9.952-1.776,14.888-2.352L215.416,1.446
			z"/>
	</g>
</g>
<g>
	<g>
		<path d="M231.68,0.158l0.608,16c4.992-0.176,10.08-0.192,15.072,0l0.64-16C242.584-0.058,237.096-0.042,231.68,0.158z"/>
	</g>
</g>
<g>
	<g>
		<path d="M152.84,19.086c-4.904,2.264-9.8,4.8-14.528,7.424l7.84,13.952c4.368-2.456,8.872-4.8,13.408-6.856L152.84,19.086z"/>
	</g>
</g>
<g>
	<g>
		<path d="M264.232,1.398L262.4,17.286c4.92,0.568,9.928,1.352,14.888,2.32l3.064-15.704C274.984,2.854,269.6,2.014,264.232,1.398z"
			/>
	</g>
</g>
<g>
	<g>
		<path d="M355.32,34.862l-8.872,13.312c4.128,2.752,8.224,5.728,12.192,8.848l9.888-12.576
			C364.232,41.07,359.792,37.838,355.32,34.862z"/>
	</g>
</g>
<g>
	<g>
		<path d="M296.224,7.694l-4.296,15.408c4.8,1.344,9.6,2.896,14.32,4.624l5.512-15.016C306.672,10.83,301.448,9.15,296.224,7.694z"
			/>
	</g>
</g>
<g>
	<g>
		<path d="M124.408,35.054c-4.528,3.048-8.968,6.272-13.176,9.6l9.904,12.56c3.888-3.072,8-6.056,12.192-8.88L124.408,35.054z"/>
	</g>
</g>
<g>
	<g>
		<path d="M326.848,18.942L320.16,33.47c4.52,2.088,9.048,4.392,13.44,6.832l7.8-13.968
			C336.648,23.694,331.76,21.198,326.848,18.942z"/>
	</g>
</g>
<g>
	<g>
		<path d="M176,95.998c-17.673,0-32,14.327-32,32s14.327,32,32,32s32-14.327,32-32S193.673,95.998,176,95.998z M176,143.998
			c-8.837,0-16-7.163-16-16s7.163-16,16-16s16,7.163,16,16S184.837,143.998,176,143.998z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
